<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">
            Sample PO
            <jni-spinner *ngIf="showLoader"></jni-spinner>
          </h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <div
            class="samplepo-panel col-auto d-flex justify-content-between gap-3 align-items-center">
            <!-- <div
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center"
              *ngIf="
                selectedSamplePO &&
                selectedSamplePO.length === 1 &&
                selectedSamplePO[0]?.purchaseOrderNumber?.includes('Temp') &&
                userRole === enumUserRole.Admin
              ">
              <i class="icon-Delete me-2"></i>
              <a class="link" (click)="deletePurchaseOrder()">Delete</a>
            </div> -->

            <a
              *ngIf="
                selectedSamplePO &&
                selectedSamplePO.length === 1 &&
                selectedSamplePO[0]?.purchaseOrderNumber?.includes('Temp') &&
                userRole === enumUserRole.Admin
              "
              (click)="deletePurchaseOrder()"
              class="delcol">
              <i class="pi pi-trash"></i> Delete
            </a>

            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportExcel()"
              class="fullwdth secondary-btn" />
            <!-- <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcelAll()">Export All excel</a>
      </div> -->

            <p-button
              label="Add New SamplePO"
              icon="pi pi-plus"
              (click)="onSamplePORedirection()"
              class="fullwdth secondary-btn" />
            <!-- 
            <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <i class="icon-Add me-2"></i>
              <a class="link" (click)="onSamplePORedirection()"
                >Add New SamplePO</a
              >
            </div> -->

            <span
              class="cross-border"
              *ngIf="isModal"
              (click)="onCloseModalEvent()"
              ><i class="pi pi-times"></i
            ></span>
          </div>
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          stripedRows
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 265px)"
          [size]="'small'"
          responsiveLayout="scroll"
          [value]="samplePOListings"
          [(selection)]="selectedSamplePO"
          styleClass="p-datatable-customers search-more"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="false"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          [paginator]="true"
          [rows]="defaultTake"
          [lazy]="true"
          (onLazyLoad)="getAllSamplepoListingData($event)"
          [totalRecords]="totalRecords"
          [globalFilterFields]="[]"
          sortMode="multiple"
          (onFilter)="onFilter($event)"
          selectionMode="multiple"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th pSortableColumn="purchaseOrderNumber">
                Sample PO #
                <p-sortIcon field="purchaseOrderNumber"></p-sortIcon>
              </th>
              <th>Vendor Name</th>
              <th>Job Name</th>
              <th>Client Name</th>
              <th>BC Name</th>
              <th>Status</th>
              <th pSortableColumn="createdBy">
                Created By <p-sortIcon field="createdBy"></p-sortIcon>
              </th>
              <th pSortableColumn="createdDate">
                Created Date <p-sortIcon field="createdDate"></p-sortIcon>
              </th>
              <th pSortableColumn="projectId">
                Project ID <p-sortIcon field="projectId"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="purchaseOrderNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="vendorName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="jobName"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="customerName"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="bcName"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="status"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th></th>
              <th>
                <jni-date-filter
                  (emitApplyFilter)="onFilterInput($event)"
                  (emitCanceFilter)="onFilterInput($event, 'clear')"
                  [columnName]="createdDateFieldName"
                  [filterMode]="filterMode"
                  [dataList]="samplePOListings">
                </jni-date-filter>
              </th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-samplePOListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="samplePOListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  [disabled]="false"
                  [value]="samplePOListing"
                  [pSelectableRow]="samplePOListing"
                  (click)="checkboxSelection()"></p-tableCheckbox>
              </td>
              <td
                (click)="
                  getCurrentSamplePo(samplePOListing.purchaseOrderNumber)
                ">
                <!-- <span class="p-column-title">Purchase Order Number</span> -->
                <ng-container
                  *ngIf="
                    !samplePOListing?.purchaseOrderNumber
                      ?.toLowerCase()
                      ?.includes('temp')
                  ">
                  <a class="link-underline">
                    {{ samplePOListing.purchaseOrderNumber }}
                  </a>
                </ng-container>
              </td>
              <td>
                <!-- <span class="p-column-title">Vendor Account Number</span> -->
                <a>{{ samplePOListing.vendorName }}</a>
              </td>
              <td>
                <!-- <span class="p-column-title">Job Name</span> -->
                {{ samplePOListing.jobName }}
              </td>
              <td>
                <!-- <span class="p-column-title">Client Name</span> -->
                {{ samplePOListing.organizationNameD365 }}
              </td>
              <td>
                <!-- <span class="p-column-title">BC Name</span> -->
                {{ samplePOListing.bcName }}
              </td>
              <td>
                <!-- <span class="p-column-title">Status</span> -->
                {{ samplePOListing.status }}
              </td>
              <td>
                <!-- <span class="p-column-title">Created By</span> -->
                {{ samplePOListing.createdBy }}
              </td>
              <td>
                <!-- <span class="p-column-title">Created Date</span> -->
                <span *ngIf="samplePOListing?.createdDate | hidedynamicsdate">
                  {{ samplePOListing.createdDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td>
                <!-- <span class="p-column-title">Project ID</span> -->
                {{ samplePOListing.projectId }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No sample po found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="samplePOSummaryDisplayModal"
  [displayModal]="samplePOSummaryDisplayModal"
  (closeEvent)="closeModalFromSamplePOSummary()"
  class="modal-header-sticky">
  <h1 class="panelHeading">SamplePO Summary</h1>
  <div class="panelBody">
    <jni-samplepo-summary
      [samplePOIdFromModal]="samplePOIdFromModal"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (purchaseOrderDeletedEvent)="closeModalFromSamplePOSummaryRefresh()"
      (closeModalEvent)="closeModalFromSamplePOSummary()"
      [isModal]="true"></jni-samplepo-summary>
  </div>
</jni-modal-stacker>
